import Vue from 'vue'
import Router from 'vue-router'
import Index from 'components/index/index'
// import TestDialog from 'components/test/dialog'
import Micro from 'components/micro/micro'
import MicroDetail from 'components/micro/micro-detail'
import Systematic from 'components/systematic/systematic'
import SystematicDetail from 'components/systematic/systematic-detail'
import FreeCourse from 'components/free-course/free-course'
import FreeCourseDetail from 'components/free-course/free-course-detail'
// import Search from 'components/search/search'
import Daka from 'components/daka/daka'
import DKDaka from 'components/daka/dk-daka'
import DKJiangshi from 'components/daka/dk-jiangshi'
import DakaDetail from 'components/daka/dk-detail'
import Play from 'components/play/play'
import SystematicIntro from 'components/systematic/systematic-intro'
import SystematicPlayList from 'components/systematic/systematic-play-list'
import { personalRouter } from './personal.js'
import JingPing from 'components/jingpin/jingpin'
// import PlayKcjs from 'components/play/play-kcjs'
// import PlayKcpj from 'components/play/play-kcpj'
import PlayRelatedCourse from 'components/play/play-related-course'
import PlayTwxq from 'components/play/play-twxq'
import JingPingSearch from 'components/jingpin/search'
import DakaSearch from 'components/daka/search'
import MicroSearch from 'components/micro/search'
import SystematicSearch from 'components/systematic/search'
import IndexSearch from 'components/index/search'
import Fenxiao from 'components/fenxiao/fenxiao'
import Blank from 'components/blank/blank'
import GKK from 'components/gkk/gkk'
import GKKSearch from 'components/gkk/search'
import GKKWk from 'components/gkk/gkk-wk'
import GKKTxk from 'components/gkk/gkk-txk'
import JPFF from 'components/jpff/jpff'
import JPFFWk from 'components/jpff/jpff-wk'
import JPFFTxk from 'components/jpff/jpff-txk'
import JPFFSearch from 'components/jpff/search'
import JPKC from 'components/jpkc/jpkc'
import JPKCWk from 'components/jpkc/jpkc-wk'
import JPKCTxk from 'components/jpkc/jpkc-txk'
import JPKCSearch from 'components/jpkc/search'
import Error from 'components/error/error'
import MyCourse from 'components/mycourse'
import Bought from 'components/mycourse/bought'
import LimitFree from 'components/mycourse/limitfree'
import Collection from 'components/mycourse/collection'
import SearchFilter from 'components/search/filter'
import SelectCarModel from 'components/search/car-model'
import Rotate from 'components/base/activity/rotate'
import Rank from 'components/rank'
import RankCourse from 'components/rank/course'
import RankPeople from 'components/rank/people'
// import Login from 'components/login/login'
// const Play = () => import('components/play/play')
Vue.use(Router)
export default new Router({
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      component: Index,
      meta: {
        title: 'golo维修课堂',
        id: 1
      }
    },
    {
      path: '/index/search/:reset?/:focus?',
      component: IndexSearch,
      meta: {
        title: '搜索',
        id: 2
      }
    },
    {
      path: '/search/filter',
      component: SearchFilter,
      meta: {
        title: '筛选'
      }
    },
    {
      path: '/search/car-model',
      component: SelectCarModel,
      meta: {
        title: '选择品牌'
      }
    },
    {
      path: '/index/search/:keyword',
      component: IndexSearch,
      meta: {
        title: '搜索'
      }
    },
    // 微课堂列表
    {
      path: '/micro',
      component: Micro,
      meta: {
        title: '微课堂',
        id: 3
      }
    },
    {
      path: '/micro/search',
      component: MicroSearch,
      meta: {
        title: '搜索',
        id: 4
      }
    },
    {
      path: '/micro/:id',
      component: MicroDetail,
      meta: {
        id: 5
      }
    },
    // 体系课列表
    {
      path: '/systematic',
      component: Systematic,
      meta: {
        title: '体系课',
        id: 6
      }
    },
    {
      path: '/systematic/search',
      component: SystematicSearch,
      meta: {
        title: '搜索',
        id: 7
      }
    },
    // 体系课详情
    {
      path: '/systematic/:id',
      component: SystematicDetail,
      meta: {
        title: '体系课',
        id: 8
      },
      children: [
        {
          path: '/',
          redirect: 'playlist',
          meta: {
            id: 9
          }
        },
        {
          path: 'intro',
          component: SystematicIntro,
          meta: {
            id: 10
          }
        },
        {
          path: 'playlist',
          component: SystematicPlayList,
          meta: {
            id: 11
          }
        }
      ]
    },
    // 个人中心
    ...personalRouter,
    // 免费课程
    {
      path: '/free-course',
      component: FreeCourse,
      meta: {
        id: 12
      }
    },
    {
      path: '/free-course/:id',
      component: FreeCourseDetail,
      meta: {
        id: 13
      }
    },
    // {
    //   path: '/search/:type',
    //   component: Search,
    //   name: 'search',
    //   meta: {
    //     id: 14
    //   }
    // },
    {
      path: '/daka',
      component: Daka,
      meta: {
        title: '大咖',
        id: 15
      },
      children: [
        {
          path: '/',
          redirect: 'dk'
        },
        {
          path: 'dk',
          component: DKDaka,
          meta: {
            id: 61
          }
        },
        {
          path: 'js',
          component: DKJiangshi,
          meta: {
            id: 62
          }
        }
      ]
    },
    {
      path: '/daka/search',
      component: DakaSearch,
      meta: {
        title: '搜索',
        id: 16
      }
    },
    {
      path: '/daka/:id',
      component: DakaDetail,
      meta: {
        title: '大咖',
        id: 17
      }
    },
    {
      path: '/play/:id/:video_id',
      component: Play,
      meta: {
        id: 18
      },
      children: [
        {
          path: '/',
          redirect: 'twxq'
        },
        // {
        //   path: 'kcjs',
        //   component: PlayKcjs,
        //   meta: {
        //     id: 19
        //   }
        // },
        {
          path: 'twxq',
          component: PlayTwxq,
          meta: {
            id: 20
          }
        },
        // {
        //   path: 'kcpj',
        //   component: PlayKcpj,
        //   meta: {
        //     id: 21
        //   }
        // }
        {
          path: 'related',
          component: PlayRelatedCourse
        }
      ]
    },
    // 精品课程
    {
      path: '/jingpin',
      component: JingPing,
      meta: {
        title: '精品课程',
        id: 22
      }
    },
    {
      path: '/jingpin/search',
      component: JingPingSearch,
      meta: {
        title: '搜索',
        id: 23
      }
    },
    // 分销
    {
      path: '/fenxiao/:url/:courseId',
      component: Fenxiao,
      name: 'fenxiao',
      meta: {
        title: '分销',
        id: 24
      }
    },
    {
      path: '/blank',
      component: Blank,
      name: 'blank',
      meta: {
        id: 25
      }
    },
    // 公开课
    {
      path: '/gkk',
      component: GKK,
      meta: {
        title: '免费专区',
        id: 48
      },
      children: [
        {
          path: '/',
          redirect: 'wk'
        },
        {
          path: 'wk',
          component: GKKWk,
          meta: {
            title: '免费专区',
            id: 49
          }
        },
        {
          path: 'txk',
          component: GKKTxk,
          meta: {
            title: '免费专区',
            id: 50
          }
        }
      ]
    },
    {
      path: '/gkk/search',
      component: GKKSearch,
      meta: {
        title: '搜索',
        id: 51
      }
    },
    {
      path: '/ff',
      component: JPFF,
      meta: {
        title: '精品付费',
        id: 52
      },
      children: [
        {
          path: '/',
          redirect: 'wk'
        },
        {
          path: 'wk',
          component: JPFFWk,
          meta: {
            title: '精品付费',
            id: 53
          }
        },
        {
          path: 'txk',
          component: JPFFTxk,
          meta: {
            title: '精品付费',
            id: 54
          }
        }
      ]
    },
    {
      path: '/ff/search',
      component: JPFFSearch,
      meta: {
        title: '搜索',
        id: 55
      }
    },
    {
      path: '/dy',
      component: JPFF,
      meta: {
        title: '订阅',
        id: 56
      }
    },
    {
      path: '/jp',
      component: JPKC,
      meta: {
        title: '精品课程',
        id: 57
      },
      children: [
        {
          path: '/',
          redirect: 'wk'
        },
        {
          path: 'wk',
          component: JPKCWk,
          meta: {
            title: '精品课程',
            id: 58
          }
        },
        {
          path: 'txk',
          component: JPKCTxk,
          meta: {
            title: '精品课程',
            id: 59
          }
        }
      ]
    },
    {
      path: '/jp/search',
      component: JPKCSearch,
      meta: {
        title: '搜索',
        id: 60
      }
    },
    {
      path: '/error',
      component: Error,
      meta: {
        title: '发生错误',
        id: 61
      }
    },
    {
      path: '/mycourse',
      component: MyCourse,
      meta: {
        title: '我的课程',
        id: 62
      },
      children: [
        {
          path: '/',
          redirect: 'bought'
        },
        {
          path: 'bought', // 已购
          component: Bought,
          meta: {
            title: '我的课程'
          }
        },
        {
          path: 'limitfree', // 限时免费
          component: LimitFree
        },
        {
          path: 'collection', // 收藏
          component: Collection
        }
      ]
    },
    {
      path: '/rotate',
      component: Rotate,
      meta: {
        title: '课堂会员专享'
      }
    },
    {
      path: '/rank',
      meta: {
        title: '排行榜'
      },
      component: Rank,
      children: [
        {
          path: '',
          redirect: 'course'
        },
        {
          path: 'course',
          component: RankCourse,
          meta: {
            title: '排行榜'
          }
        },
        {
          path: 'people',
          component: RankPeople,
          meta: {
            title: '排行榜'
          }
        }
      ]
    }
    /** {
      path: '/login',
      component: Login,
      meta: {
        title: '登陆',
        id: 62
      }
    }, **/
    /** {
      path: '/test-dialog',
      component: TestDialog,
      meta: {
        title: '测试'
      }
    } **/
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js